import ItemsDisplayPageScreen from './items-display-page-screen.component';

export default ItemsDisplayPageScreen;
